import { useContext } from 'react';
import { CustomTableData } from "common";
import { Button } from '@mui/material'
import { Edit3, Info, Trash2 } from 'react-feather'
import { TooltipInformation } from 'common';
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'

export const VehiclesSalesTable = ({useFetchInit}) => {

  const {
    FetchData,
    Actions,
    globalStates
  }= useFetchInit


  const {fetchAllVehicleSales:{vehicleSales}} = FetchData

  const {handleClickFetchInfoSales, handleClickDeleteVehiclSale} = Actions

  // const {data, deleteRecord, getDocumentRegistry} = useContext(VehicleAppliesContext);
  
  const columnConfig = [
    {
      headerName: 'info',
      maxWidth: 80,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      cellRenderer: (params) => {

        const {
          idventa,
          usuario_creo,
          fecha_creo,
          usuario_modifico,
          fecha_modifico,
        } = params.data;
        
        return <TooltipInformation
          idregistro={idventa}
          usuario_creo={usuario_creo}
          fecha_creo={fecha_creo}
          usuario_modifico={usuario_modifico}
          fecha_modifico={fecha_modifico}
        />
      },
    },
    { field: "contrato_codigo", headerName: "IDENTIFICADOR", minWidth: 140 },
    { field: "fecha_venta", headerName: "FECHA", minWidth: 140, filter: true },
    { field: "datos_cliente", headerName: "DATOS DEL CLIENTE", minWidth: 300, filter: true },
    { field: "descripcion_vehicle", headerName: "VEHICULO", minWidth: 240, filter: true },
    { field: "monto_venta", headerName: "MONTO DE VENTA", minWidth: 200, filter: true },
    {
      headerName: "Aprobacion",
      field: "aprobacion_check",
      minWidth: 200,
      maxWidth: 200,
      filter: true,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      cellClass: (params) => {
        if(params.value === 'Pendiente Aprobacion') return 'bg-warning';
        if(params.value === 'Pendiente Transpaso') return 'bg-warning';
        if(params.value === 'Rechazado') return 'bg-danger';
        if(params.value === 'Devuelto a Gestor') return 'bg-danger';
        if(params.value === 'Devuelto a Juridico') return 'bg-danger';
      },
      cellRenderer: (params) => {
        const { idcredito, aprobacion_usuario, aprobacion_fecha } = params.data

        if(params.value === 'Pendiente Aprobacion') return (
            <TooltipAprobacion
                tag_id='tooltip_arr_solicitudes_aprobacion_'
                class_icon='fa-solid fa-user-clock'
                text_span='Pendiente Aprobacion'
                idcontrato={idcredito}
                aprobacion_usuario={aprobacion_usuario}
                aprobacion_fecha={aprobacion_fecha}
            />
        );

        if(params.value === 'Pendiente Transpaso') return (
            <TooltipAprobacion
                tag_id='tooltip_arr_solicitudes_aprobacion_'
                class_icon='fa-solid fa-user-lock'
                text_span='Pendiente Transpaso'
                idcontrato={idcredito}
                aprobacion_usuario={aprobacion_usuario}
                aprobacion_fecha={aprobacion_fecha}
            />
        );

        if(params.value === 'Rechazado') return (
            <TooltipAprobacion
                tag_id='tooltip_arr_solicitudes_aprobacion_'
                class_icon='fa-solid fa-circle-xmark'
                text_span='Rechazado'
                idcontrato={idcredito}
                aprobacion_usuario={aprobacion_usuario}
                aprobacion_fecha={aprobacion_fecha}
            />
        );
        if(params.value === 'Devuelto a Gestor') return (
            <TooltipAprobacion
                tag_id='tooltip_arr_solicitudes_aprobacion_'
                class_icon='fa-solid fa-user-times'
                text_span='Devuelto a Gestor'
                idcontrato={idcredito}
                aprobacion_usuario={aprobacion_usuario}
                aprobacion_fecha={aprobacion_fecha}
            />
        );
        if(params.value === 'Devuelto a Juridico') return (
          <TooltipAprobacion
              tag_id='tooltip_arr_solicitudes_aprobacion_'
              class_icon='fa-solid fa-user-times'
              text_span='Devuelto a Juridico'
              idcontrato={idcredito}
              aprobacion_usuario={aprobacion_usuario}
              aprobacion_fecha={aprobacion_fecha}
          />
      );
    }
    },
    {
      headerName: "OPCIONES",
      minWidth: 440,
      cellRenderer: (params) => {

        const {idventa, aprobacion_check} = params.data
        if ( (aprobacion_check === 'Pendiente Transpaso') || (aprobacion_check === 'Rechazado') || (aprobacion_check === 'Devuelto a Gestor') ) return (
          <>
              <Button 
                  startIcon = { <Info/>}
                  variant='contained'
                  size='small' 
                  color='info'
                  sx={{ marginRight: '8px' }}
                  onClick={() => handleClickFetchInfoSales(idventa, 'READONLY')} 
                  style={ { width: 150 } }
                  > 
                  Solicitud
              </Button>
          </>
      )
           
      // Si el contrato está pendiente de aprobación se debe permitir modificar
      if ( aprobacion_check === 'Pendiente Aprobacion') return(
          <>
              <Button 
                  startIcon = { <Edit3/>}
                  variant='contained'
                  size='small' 
                  color='success'
                  sx={{ marginRight: '8px' }}
                  onClick={() => handleClickFetchInfoSales(idventa, 'EDITABLE')} 
                  style={ { width: 150 } }
                  > 
                  Responder
              </Button>
          </>
          
      )
      },
    },
  ];
  return (
    <>
      <CustomTableData
        rowConfig={vehicleSales}
        // rowConfig={[]}
        columnConfig={columnConfig} />
    </>
  );
};
